type TShiftTagCellProps = {
  name: string;
  color: string;
};

export const ShiftTagCell = ({ name, color }: TShiftTagCellProps) => {
  return (
    <div className="tw-flex tw-items-center tw-gap-0.8">
      <span
        className="tw-w-1 tw-h-1 tw-rounded-full tw-shrink-0"
        style={{ backgroundColor: color }}
      />
      <span className="tw-cds-font-body-01-md">{name}</span>
    </div>
  );
};
